import { FC, useEffect } from 'react';
import { isNil } from 'lodash';
import { Container } from 'containers/ExpertAssignedMissionShow/style';
import LegalProceedingTabs from 'components/LegalProceedingTabs';
import { connect, useDispatch, useSelector } from 'react-redux';
import { injectIntl, IntlShape } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { get, isEmpty } from 'lodash';
import {
  makeSelectKeycloakToken,
  makeSelectListings,
} from 'containers/AppContainer/selectors';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { Listings } from 'containers/AppContainer/typings';
import {
  requestClaimRecap,
  resetStoreClaim,
} from 'containers/RecapManagerPage/actions';
import { makeSelecClaimRecap } from 'containers/RecapManagerPage/selectors';
import { resetStoreExpertise } from 'containers/ExpertAssignedMissions/actions';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import {
  requestSearchClaims,
  resetSearchClaimsStore,
} from 'containers/IdentificationPage/actions';
import { resetStoreDetailsExpertise } from 'containers/ExpertExpertise/actions';
import { requestSetStoreExpertise } from 'containers/CourtManagerAssignedExpertise/actions';
import routesHelper from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { translate } from 'containers/services/translate';
import messages from 'containers/ExpertAssignedMissionShow/messages';
import ExpertRecap from 'containers/ExpertRecap';
import { requestExpertExpertiseMissions } from 'containers/ExpertAssignedMissions/actions';
import ExpertExpertise from 'containers/ExpertExpertise';
import { useQuery } from 'containers/services/routes-helper';
import { getMissionByIdAction } from 'containers/ExpertAssignedMissionShow/actions';
import { requestCreateExpertiseVictim } from 'containers/ExpertExpertise/actions';
import {
  isAssignedExpert,
  renderMissionId,
  renderSearchQuery,
} from 'containers/ExpertAssignedMissionShow/utils';
import { extractOpposingParties } from 'containers/PreOpeningPage/utils';
import { resolveSagisClaim } from 'helpers/utils';
import { makeSelectSagisClaim } from 'containers/CourtManagerLegalProceedings/Provision/redux/selectors';
import { requestSagisClaimInfo } from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import { CLAIM_STATUS } from 'containers/data-structure';
import { requestGetDocByDocumentumId } from 'containers/common/UploadDocument/actions';
import { ClaimRecapType } from 'typings/claimTypes';
import { MISSION_NATURE } from 'containers/ExpertExpertise/ConcernedExpertise/constants';

interface ExpertAssignedMissionShowProps {
  intl: IntlShape;
  listings: Listings;
  requestClaimRecap: Function;
  claimRecap: ClaimRecapType;
  policyInfo: { sagis: {} };
  match: { params: { missionId: string } };
  sagis_code: any;
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  requestExpertExpertiseMissions: Function;
  requestCreateExpertiseVictim: Function;
  sagisInfo: any;
  requestSagisClaimInfo: Function;
  resetStoreClaim: Function;
  resetStoreExpertise: Function;
  resetStoreDetailsExpertise: Function;
  requestGetDocByDocumentumId: Function;
  requestSetStoreExpertise: Function;
}

const ExpertAssignedMissionShow: FC<ExpertAssignedMissionShowProps> = props => {
  const query = useQuery();
  const dispatch = useDispatch();
  const currentTabIndex = parseInt(query.get('tab') as string) || 0;

  const missionId = props.match.params.missionId;
  const mission = useSelector((state: any) =>
    get(state.toJS(), ['expertiseMissions', 'expertiseMission'], []),
  );
  const victims = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'victims'], []),
  );
  const token = useSelector(makeSelectKeycloakToken());
  const vehicles = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'vehicules'], []),
  );
  useEffect(() => {
    dispatch(getMissionByIdAction(renderMissionId(missionId)));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missionId, token]);
  const claim = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap']),
  );
  useEffect(() => {
    if (!isEmpty(props.claimRecap)) {
      const searchQuery = renderSearchQuery(props.claimRecap);
      props.requestSearchClaims(searchQuery);
    }
    if (
      featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO) &&
      get(props.claimRecap, 'claim.status', '') === CLAIM_STATUS.VALIDATED
    ) {
      props.requestSagisClaimInfo(
        get(props.claimRecap, 'claim.claimNumber', null),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.claimRecap, token]);
  useEffect(() => {
    if (mission && props.sagis_code) {
      if (!isAssignedExpert(mission, props.sagis_code)) {
        routesHelper.pushTo(PAGES.EXPERT_ASSIGNED_MISSIONS)();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mission, props.sagis_code, !victims, !vehicles, token, claim]);
  useEffect(() => {
    if (!isNil(get(mission, 'claimId', null))) {
      props.requestClaimRecap(get(mission, 'claimId', null));
    }
    props.requestExpertExpertiseMissions([1, 2, 3, 4, 5]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missionId, token]);

  const labels =
    get(mission, 'nature') != MISSION_NATURE.PROVISIONAL_JUDICIARY
      ? [translate(messages.recap, props), translate(messages.expertise, props)]
      : [translate(messages.expertise, props)];
  const cleanStore = () => {
    props.resetStoreClaim();
    props.resetSearchClaimsStore();
    props.resetStoreExpertise();
    props.resetStoreDetailsExpertise();
    props.requestSetStoreExpertise();
  };
  useEffect(() => {
    return () => {
      cleanStore();
    };
  }, []);
  return (
    <Container>
      <LegalProceedingTabs labels={labels} currentTabIndex={currentTabIndex}>
        {get(mission, 'nature') != MISSION_NATURE.PROVISIONAL_JUDICIARY && (
          <ExpertRecap
            mission={mission}
            listings={props.listings}
            storedClaimToPreopen={null}
            requestClaimRecap={props.requestClaimRecap}
            claimRecap={props.claimRecap}
            policyInfo={props.policyInfo}
            requestSearchClaims={props.requestSearchClaims}
            resetSearchClaimsStore={props.resetSearchClaimsStore}
            claimId={claim.id}
            shouldDisplayBreadCrumbs={false}
            className="recap-bloc"
            shouldNotGetClaim
            stakeholders={null}
            sagis_code={props.sagis_code}
            sagisOpposingParties={extractOpposingParties(
              get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []),
            )}
            resetStoreClaim={props.resetStoreClaim}
          />
        )}
        <ExpertExpertise
          victim={
            isEmpty(props.claimRecap)
              ? get(mission, 'victims[0]', {})
              : victims.find(
                  (victim: any) =>
                    victim.id === parseInt(get(mission, 'victims[0].id', '')),
                )
          }
          vehicle={vehicles.find(
            (vehicle: any) =>
              vehicle.id === parseInt(get(mission, 'vehicles[0].id', '')),
          )}
          mission={mission}
          requestCreateVictimExpertise={props.requestCreateExpertiseVictim}
          sagis_code={props.sagis_code}
          sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
          sagisOpposingParties={extractOpposingParties(
            get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []),
          )}
          claimRecap={props.claimRecap}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          requestClaimRecap={props.requestClaimRecap}
          requestSearchClaims={props.requestSearchClaims}
        />
      </LegalProceedingTabs>
    </Container>
  );
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  claimRecap: makeSelecClaimRecap(),
  policyInfo: makeSelectSearchClaims(),
  sagisInfo: makeSelectSagisClaim(),
});

const mapDispatchToProps = {
  requestClaimRecap,
  requestSearchClaims,
  resetSearchClaimsStore,
  requestExpertExpertiseMissions,
  requestCreateExpertiseVictim,
  requestSagisClaimInfo,
  resetStoreClaim,
  resetStoreExpertise,
  resetStoreDetailsExpertise,
  requestGetDocByDocumentumId,
  requestSetStoreExpertise,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ExpertAssignedMissionShow));
